import React from "react";

import { css, SerializedStyles } from "@emotion/react";

import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { fontColor, FONTS, fontSize } from "../../../styles/fonts";
import cn from "classnames";

type AsProp<E extends React.ElementType> = {
  as?: E;
};

type SwarovskiTagProps = AsProp<"li" | "div"> & {
  className?: string;
  css?: Array<SerializedStyles>;
  label: string;
  size?: "small" | "regular" | "tiny";
  children: React.ReactNode;
};

export const SwarovskiTag: ReactTFC<SwarovskiTagProps> = ({ css, className, label, size, children, as }) => {
  const isLong = label.length > 40;

  const Tag = as || "li";

  return (
    <Tag
      css={[...styles, ...(css || [])]}
      className={cn(className, {
        long: isLong,
        small: size === "small",
        tiny: size === "tiny",
        regular: size === "regular",
      })}
      title={label}
    >
      {children}
    </Tag>
  );
};

export const SwarovskiPriceTag: ReactTFC<Pick<SwarovskiTagProps, "css" | "label" | "children">> = props => (
  <SwarovskiTag
    {...props}
    as="div"
    css={[
      ...(props.css || []),
      FONTS.SwarovskiFutura500,
      css`
        color: ${CSS_COLORS.Green};
        white-space: nowrap;
      `,
    ]}
    label={props.label}
    size="small"
  >
    {props.children}
  </SwarovskiTag>
);

export const styles = [
  FONTS.SwarovskiFutura300,
  fontColor.black,
  fontSize.x2s,

  css`
    &.regular {
      padding: 8px 10px 6px;
      border-radius: 8px;
    }

    &.small {
      padding: 3px 6px 2px;
      border-radius: 4px;
    }

    &:not(.tiny) {
      text-transform: uppercase;
      border: 1px solid ${CSS_COLORS.Grey};
    }

    display: inline-block;

    // &:not(.long) {
    //   text-align: center;
    // }
  `,
];
